

<div class="confirmation-modal">
    <div class="cancel-btn">
        <span class="material-symbols-outlined pointer" (click)="cancelAction()">close</span>
    </div>

   <div class="delete-img" >
       <svg width="74" height="66" viewBox="0 0 74 66" fill="none" xmlns="http://www.w3.org/2000/svg" *ngIf="!data.willBeEnabled">
            <mask id="mask0_19394_19096" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="74"
                height="66">
                <rect x="0.0273438" y="0.5" width="73.069" height="65" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_19394_19096)">
                <path
                    d="M36.5606 63.4455C32.349 63.4455 28.3911 62.6463 24.6869 61.0479C20.9827 59.4495 17.7606 57.2803 15.0205 54.5402C12.2804 51.8001 10.1112 48.578 8.51281 44.8738C6.91443 41.1696 6.11523 37.2117 6.11523 33.0001C6.11523 28.7885 6.91443 24.8306 8.51281 21.1264C10.1112 17.4222 12.2804 14.2001 15.0205 11.46C17.7606 8.71988 20.9827 6.55065 24.6869 4.95226C28.3911 3.35388 32.349 2.55469 36.5606 2.55469C40.7723 2.55469 44.7302 3.35388 48.4343 4.95226C52.1385 6.55065 55.3607 8.71988 58.1008 11.46C60.8408 14.2001 63.0101 17.4222 64.6085 21.1264C66.2068 24.8306 67.006 28.7885 67.006 33.0001C67.006 37.2117 66.2068 41.1696 64.6085 44.8738C63.0101 48.578 60.8408 51.8001 58.1008 54.5402C55.3607 57.2803 52.1385 59.4495 48.4343 61.0479C44.7302 62.6463 40.7723 63.4455 36.5606 63.4455ZM36.5606 57.3564C39.3007 57.3564 41.9393 56.9124 44.4764 56.0244C47.0136 55.1364 49.3477 53.8552 51.4789 52.1807L17.38 18.0818C15.7055 20.213 14.4243 22.5472 13.5363 25.0843C12.6483 27.6214 12.2043 30.26 12.2043 33.0001C12.2043 39.7996 14.5638 45.5588 19.2829 50.2779C24.0019 54.9969 29.7612 57.3564 36.5606 57.3564ZM55.7412 47.9183C57.4157 45.7872 58.697 43.453 59.585 40.9159C60.473 38.3788 60.917 35.7402 60.917 33.0001C60.917 26.2006 58.5574 20.4414 53.8384 15.7223C49.1194 11.0033 43.3601 8.64377 36.5606 8.64377C33.8205 8.64377 31.1819 9.08776 28.6448 9.97575C26.1077 10.8637 23.7736 12.145 21.6424 13.8195L55.7412 47.9183Z"
                    fill="#FE1216" />
            </g>
        </svg>
        <div class="icon">
        <mat-icon [class.enable-icon]="data.willBeEnabled" [class.disable-icon]="!data.willBeEnabled" *ngIf="data.willBeEnabled ">
            {{data.willBeEnabled ? 'check_circle' : 'cancel'}}
        </mat-icon>
    </div>
    </div>

    <h1 matDialogTitle>
        <ng-container *ngIf="data.isInternalService; else defaultToggleText">
            Are you sure you want to {{data.willBeEnabled ? 'enable' : 'disable'}} show internal checklist in chat for
            <strong>{{data.serviceName}}</strong>.
        </ng-container>
        <ng-template #defaultToggleText>
            Are you sure you want to {{data.willBeEnabled ? 'enable' : 'disable'}}-<strong>{{data.serviceName}}</strong> {{data?.location==='service'?'service':'restaurant'}}.
        </ng-template>
    </h1>
    
    <div *ngIf="!data.willBeEnabled && !data.isInternalService">
        <strong class="mb-2 d-block">Reason</strong>
        <mat-form-field class="w-100" appearance="outline">
            <mat-select [(ngModel)]="selectedReason" placeholder="Select">
                <mat-option value="Lunch Time">Lunch time</mat-option>
                <mat-option value="Under Maintenance">Under maintenance</mat-option>
                <mat-option value="Staff Not available">Staff not available</mat-option>
                <mat-option value="Other">Other</mat-option>
            </mat-select>
        </mat-form-field>
        
        <div *ngIf="selectedReason === 'Other'">
            <strong class="mb-2 d-block">Other</strong>
            <mat-form-field class="w-100" appearance="outline">
                <input matInput type="text" [(ngModel)]="otherReason" placeholder="Enter other reason">
            </mat-form-field>
        </div>
    </div>

    <div class="confirmation-btn-grp">
        <button class="btn primary" 
                (click)="confirmAction()" 
                [disabled]="!data.willBeEnabled && !data.isInternalService && (!selectedReason || (selectedReason === 'Other' && !otherReason))">
            Confirm
        </button>
    </div>
</div>